<template>
  <v-container fluid id="home" class="home fill-height" >
    <HomeContent/>
  </v-container>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
//import HomeContent from '@/components/Econtract.vue'
import HomeContent from '@/components/HomeContent.vue'

export default {
  name: 'Home',
  components: {
    //HelloWorld,
    HomeContent
  }
}
</script>


